import * as React from 'react'
import { ListItemButton, ListItemText, Typography, Divider, Box } from '@mui/material'

export default function ListMailBoxFolders({ item, selectedItem, onClick }) {
  if (!item) return null

  const handleListItemClick = () => {
    if (onClick) onClick(item.name, item.id)
  }

  return (
    <>
      <ListItemButton alignItems='flex-start' selected={selectedItem === item.id} onClick={handleListItemClick}>
        <ListItemText
          primary={
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
              {item.icon?.()}
              <Typography component='span' variant='body2' color='text.primary'>
                {item.displayname}
              </Typography>
            </Box>
          }
        />
      </ListItemButton>
      <Divider component='li' />
    </>
  )
}
